<template>
    <div
        class="inline-block rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full sm:w-auto"
    >
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4 z-10">
            <ButtonCloseSm class="flex-shrink-0" @click="$emit('close')" />
        </div>
        <div
            class="sm:vh-100 relative lg:max-w-7xl mx-auto grid grid-cols-1 md:flex md:items-stretch overflow-y-auto no-scrollbar md:overflow-hidden"
        >
            <Categories :selected="modalData.selectedCategory" @selectCategory="selectCategory" />
            <Templates
                @selectTemplate="selectTemplate"
                :selectedCategory="modalData.selectedCategory"
            />
        </div>
    </div>
</template>

<script>
import { ButtonCloseSm } from "@easy/ui/buttons";

import { mapActions } from "vuex";
import Categories from "./Categories.vue";
import Templates from "./Templates.vue";

export default {
    name: "cTemplateModal",
    components: {
        Categories,
        Templates,
        ButtonCloseSm,
    },
    props: {
        modalData: Object,
    },
    created() {
        this.getTemplates();
    },
    methods: {
        ...mapActions("banner", ["getTemplates"]),
        closeModal() {
            this.$emit("close");
        },
        selectTemplate(template) {
            this.modalData.selectedTemplate = template;
            this.modalData.callback();
            this.$emit("close");
        },
        selectCategory(category) {
            this.modalData.selectedCategory = category;
        },
    },
};
</script>
